import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6be9a3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card p-4" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 align-items-center\" data-v-6be9a3d6><div data-v-6be9a3d6><svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-6be9a3d6><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-6be9a3d6></rect><path d=\"M31.0836 25.2036L29.2696 24.0877C29.4527 23.0353 29.4527 21.9556 29.2696 20.9032L31.0836 19.7873C31.2923 19.6603 31.386 19.3972 31.3178 19.1522C30.8452 17.5373 30.0404 16.0766 28.9886 14.8609C28.8268 14.6749 28.5628 14.6296 28.3584 14.7566L26.5444 15.8725C25.7822 15.1739 24.905 14.6341 23.9555 14.2803V12.053C23.9555 11.7989 23.7894 11.5767 23.5552 11.5222C21.9924 11.1502 20.3914 11.1684 18.9053 11.5222C18.6711 11.5767 18.505 11.7989 18.505 12.053V14.2848C17.5597 14.6432 16.6825 15.183 15.9161 15.877L14.1063 14.7611C13.8977 14.6341 13.6379 14.6749 13.4761 14.8655C12.4244 16.0766 11.6196 17.5373 11.1469 19.1568C11.0745 19.4017 11.1725 19.6648 11.3811 19.7918L13.1951 20.9078C13.012 21.9602 13.012 23.0398 13.1951 24.0922L11.3811 25.2082C11.1725 25.3352 11.0788 25.5983 11.1469 25.8432C11.6196 27.4581 12.4244 28.9188 13.4761 30.1345C13.6379 30.3205 13.9019 30.3659 14.1063 30.2389L15.9203 29.123C16.6825 29.8215 17.5597 30.3614 18.5093 30.7152V32.947C18.5093 33.2011 18.6753 33.4233 18.9095 33.4778C20.4723 33.8498 22.0734 33.8316 23.5595 33.4778C23.7936 33.4233 23.9597 33.2011 23.9597 32.947V30.7152C24.905 30.3568 25.7822 29.817 26.5487 29.123L28.3627 30.2389C28.5713 30.3659 28.8311 30.3251 28.9929 30.1345C30.0446 28.9234 30.8494 27.4627 31.3221 25.8432C31.386 25.5937 31.2923 25.3306 31.0836 25.2036ZM21.2302 26.1245C19.3524 26.1245 17.8237 24.496 17.8237 22.4955C17.8237 20.495 19.3524 18.8664 21.2302 18.8664C23.1081 18.8664 24.6368 20.495 24.6368 22.4955C24.6368 24.496 23.1081 26.1245 21.2302 26.1245Z\" fill=\"#203972\" data-v-6be9a3d6></path></svg></div><div data-v-6be9a3d6><p class=\"m-0 subtitulo cor_texto_1\" data-v-6be9a3d6>Config. preferências do grupo</p></div></div>", 1)
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tipo Oferta", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Layout App", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Checklist Adicional", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("li", null, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: _ctx.preferGrupoProp.tipoOferta,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.preferGrupoProp.tipoOferta) = $event)),
        placeholder: "Selecione um cargo..."
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayTipoOferta, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.nome,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("li", null, [
      _hoisted_4,
      _createVNode(_component_el_select, {
        modelValue: _ctx.preferGrupoProp.tipoApp,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.preferGrupoProp.tipoApp) = $event)),
        placeholder: "Selecione um cargo..."
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayLayoutApp, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.codBandeira,
              label: item.descricao,
              value: item.codBandeira
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("li", null, [
      _hoisted_5,
      _createVNode(_component_el_select, {
        modelValue: _ctx.preferGrupoProp.checklistAdicional,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.preferGrupoProp.checklistAdicional) = $event)),
        placeholder: "Selecione um cargo..."
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayChecklistAdicional, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.checklist,
              label: item.nome,
              value: item.checklist
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}